import { Component, Input } from '@angular/core';
import { ModalOffcanvasService } from '../../../../../services/modal-offcanvas.service';
import { OffcanvasHistoryService } from '../../../../../services/offcanvas-history.service';
import { OpenWriteReviewModalService } from '../../../../../services/openWriteReviewModal.service';
import { ScreenSizeService } from '../../../../../services/utils/screenSize.service';
import { Partner } from '../../../../models/partner.model';
import { Review } from '../../../../models/review.model';
import { ReviewDetailsComponent } from '../../review-details/review-details.component';
import { ReviewSidebarComponent } from '../../review-sidebar/review-sidebar.component';
import { ViewStatus } from '@uranda/ui';

@Component({
  selector: 'app-latest-reviews',
  templateUrl: './latest-reviews.component.html',
  styleUrls: ['./latest-reviews.component.css'],
  standalone: false
})
export class LatestReviewsComponent {
  @Input() reviews: Review[] = [];
  @Input() partner?: Partner;
  @Input() isOffcanvas = false;
  @Input() viewStatus: ViewStatus = ViewStatus.LOADING;
  @Input() reviewStats?: Review;

  ViewStatus = ViewStatus;

  constructor(
    private openWriteReviewModalService: OpenWriteReviewModalService,
    private modalOffcanvasService: ModalOffcanvasService,
    private screenSizeService: ScreenSizeService,
    private offcanvasHistory: OffcanvasHistoryService
  ) {}

  openWriteReviewModal(): void {
    if (!this.partner) return;

    this.openWriteReviewModalService.openWriteReviewModal(
      { id: this.partner.id, name: this.partner.name },
      false,
      this.isOffcanvas
    );
  }

  reviewDetails(review: Review): void {
    this.modalOffcanvasService.openComponent(
      ReviewDetailsComponent,
      {
        review,
        isOffcanvas: this.screenSizeService.isMobile || this.isOffcanvas
      },
      undefined,
      this.isOffcanvas
    );
  }

  viewAllReviews(): void {
    const offcanvasRef = this.offcanvasHistory.open(ReviewSidebarComponent, {
      position: 'end',
      scroll: false,
      backdrop: true,
      panelClass: 'reviews-offcanvas-panel',
    });

    offcanvasRef.componentInstance.partnerId = this.partner?.id;
    offcanvasRef.componentInstance.clinicName = this.partner?.name;
    offcanvasRef.componentInstance.averageRating = this.partner?.averageRate;
    offcanvasRef.componentInstance.totalReviews = this.partner?.reviewsCount;
    offcanvasRef.componentInstance.reviewStats = this.reviewStats;
    offcanvasRef.componentInstance.viewStatus = this.viewStatus;
  }

  get hasMoreReviews(): boolean {
    return (this.partner?.reviewsCount ?? 0) > this.reviews.length;
  }
}